import styled from 'styled-components';

import { SvgStyled } from '@sternum/web/icons/icons.styles';

export const SpinnerIconStyled = styled(SvgStyled)`
  animation: animateSpinner 1s linear infinite;

  @keyframes animateSpinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
